const InfoIcon = () => {
  return (
    <svg
      style={{ color: "var(--gray1)" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48603 2 2 6.48604 2 12C2 17.514 6.48603 22 12 22C17.514 22 22 17.514 22 12C22 6.48604 17.514 2 12 2ZM12 3.5C16.7033 3.5 20.5 7.2967 20.5 12C20.5 16.7033 16.7033 20.5 12 20.5C7.29669 20.5 3.5 16.7033 3.5 12C3.5 7.2967 7.29669 3.5 12 3.5ZM12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8C11 8.26522 11.1054 8.51957 11.2929 8.70711C11.4804 8.89464 11.7348 9 12 9C12.2652 9 12.5196 8.89464 12.7071 8.70711C12.8946 8.51957 13 8.26522 13 8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7ZM11.9883 10.4893C11.7895 10.4924 11.6002 10.5742 11.4617 10.7169C11.3233 10.8595 11.2471 11.0513 11.25 11.25V16.75C11.2486 16.8494 11.267 16.9481 11.304 17.0403C11.3411 17.1325 11.3961 17.2164 11.4659 17.2872C11.5357 17.358 11.6188 17.4142 11.7105 17.4526C11.8022 17.4909 11.9006 17.5107 12 17.5107C12.0994 17.5107 12.1978 17.4909 12.2895 17.4526C12.3812 17.4142 12.4643 17.358 12.5341 17.2872C12.6039 17.2164 12.6589 17.1325 12.696 17.0403C12.733 16.9481 12.7514 16.8494 12.75 16.75V11.25C12.7514 11.1496 12.7327 11.05 12.6949 10.957C12.6571 10.8639 12.6011 10.7795 12.53 10.7085C12.459 10.6376 12.3745 10.5816 12.2814 10.544C12.1883 10.5063 12.0887 10.4877 11.9883 10.4893Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InfoIcon;
